export default __webpack_public_path__ + "static/media/textura-solo.9829d4ea.svg";